module.exports = __webpack_public_path__ + "img/product_102.59e9cc0.webp";